import {JsonObject, JsonProperty} from 'json2typescript';

@JsonObject('ExecutionResult')
export class ExecutionResult {
    @JsonProperty('added',Number,true)
    added = 0;
    @JsonProperty('replaced',Number,true)
    replaced = 0;
    @JsonProperty('ignored',Number,true)
    ignored = 0;
    @JsonProperty('errors',[String],true)
    errors:string[] = [];
}
